import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CoreAuthLibClientService } from "@app/core-auth-lib/services/core-auth-lib-client.service";
import { DataFeedEndPointParam } from "@app/core/data/DataFeedEndPointParam";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";

const service = environment.cloudbedsApi.url;
const truePayService = environment.truePayApi.url;
const newservice = environment.cloudbedsApi.url; // 'https://hos-api-qa.trueomni.com/api';//
@Injectable({
  providedIn: "root",
})
export class CloudbedsService {
  private BASE_URL = environment.coreAuthLib.base_url;

  constructor(
    private http: HttpClient,
    private coreAuth: CoreAuthLibClientService
  ) {}

  async findReservation(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/lookup2`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }
  async getRooms() {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/getRooms`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .get(url, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async getUpSells(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/getUpsells`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async addUpSells(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/addUpsells`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async upgradeRoom(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/upgradeRoom`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async getInvoice(body: any) {
    var propertyId = body.propertyId ? `/${body.propertyId}` : '';
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/getReservationInvoice/${body.reservationId}${propertyId}`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .get(url, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async checkin(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/checkin`;
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async checkout(code: string, propertyId: number) {
    const token = await this.coreAuth.getToken();
    const url = `${newservice}/cloudbeds/checkout`;
    const body = {
      reservationId: code,
      propertyId: propertyId
    };
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async addGuest(body: object) {
    const token = await this.coreAuth.getToken();
    const url = `${service}/cloudbeds/addguest`;
    // const body = {
    //   reservationId: code,
    // };
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }
  async truePayCheckout(reservationId: string, successUrl: string, cancelUrl: string, customerEmail: string, amount: number) {
    const token = await this.coreAuth.getToken();
    const url = `${truePayService}/Checkout/create`;
    const body = {
      successUrl: successUrl,
      cancelUrl: cancelUrl,
      customerEmail: customerEmail,
      items: [
        { name: "Reservation: " + reservationId, amount: amount * 100, quantity: 1, currency: "usd" }
      ],
      metadata: { propertyName: environment.site.name },
      mode: "payment"
    };
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }
  async processPayment(reservationId: string, amount: number, propertyId: number) {
    const token = await this.coreAuth.getToken();
    const url = `${service}/cloudbeds/payment`;
    const body = {
      ReservationId: reservationId,
      Amount: amount,
      PropertyId: propertyId
    };
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  async paymentIntent(code?: string) {
    const token = await this.coreAuth.getToken();
    const url = `${service}/payment/create-payment-intent`;
    const body = {
      Amount: 1000,
      Currency: "MXN",
    };
    const headers = this.getHeaders(token.tokenType, token.accessToken);
    return await this.http
      .post(url, body, { headers: headers })
      .pipe(take(1))
      .toPromise();
  }

  private getHeaders(tokenType?: string, accessToken?: string): HttpHeaders {
    return new HttpHeaders({
      Authorization: `${tokenType} ${accessToken}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  }
}
